module.exports = __webpack_public_path__ + "media/images/help/line/eyecatch-point-3-9136122f23f7734e73e8d825c8252187.jpg";